module.exports = __webpack_public_path__ + "ec5f424e43d6ef1a0db311dc4fc5f6df.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-amy.png
// module id = 605
// module chunks = 30